import React, { useEffect } from "react";
import { VirtualConfig } from "./type";
import { Button, Form, Row } from "antd";
import NumericVirtualMappingInput from "./Inputs/NumericVirtualMappingInput";
import { aggregatedQuestionTypes } from "./misc";
import CategoricalVirtualMappingInput from "./Inputs/CategoricalVirtualMappingInput";
import DatasetPicker, { DatasetProvider } from "./Distributions/DatasetPicker";
import NumericVirtualMappingDistribution from "./Distributions/NumericVirtualMappingDistribution";

type VirtualMappingFormProps = {
  value?: VirtualConfig;
  onChange?: (value: VirtualConfig) => void;
  mapping: any;
  field: any;
  mode?: "form" | "realtime";
  defaultSurveyId?: string;
};
const VirtualMappingForm: React.FC<VirtualMappingFormProps> = ({ value, onChange, mapping, field, defaultSurveyId, mode = "form" }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (mode === "realtime") {
      form.setFieldsValue(value);
    }
  }, [value, form, mode]);
  return (
    <Form
      form={form}
      onFinish={(values) => {
        onChange?.({ referToQuestionCode: field.questionCode, ...values });
      }}
      onChange={() => {
        if (mode === "realtime") form.submit();
      }}
      initialValues={value}
    >
      {/*<Form.Item label="Refer to question code" name="referToQuestionCode">
        <Input disabled />
      </Form.Item>*/}
      <DatasetProvider defaultSurveyId={defaultSurveyId}>
        <DatasetPicker style={{ marginBottom: 10 }} mappingId={mapping.id} />

        {aggregatedQuestionTypes.numeric.includes(field.questionType) && (
          <>
            <Form.Item name="categories">
              <NumericVirtualMappingInput />
            </Form.Item>
            <Form.Item noStyle dependencies={[["categories"], ["referToQuestionCode"]]}>
              {({ getFieldsValue }) => {
                return (
                  <NumericVirtualMappingDistribution
                    value={{
                      referToQuestionCode: field.questionCode,
                      ...getFieldsValue(),
                    }}
                  />
                );
              }}
            </Form.Item>
          </>
        )}
        {aggregatedQuestionTypes.categorical.includes(field.questionType) && (
          <Form.Item name="categories">
            <CategoricalVirtualMappingInput referToQuestionCode={field.questionCode} />
          </Form.Item>
        )}
      </DatasetProvider>
      {mode === "form" && (
        <Row justify="end" style={{ marginTop: 10 }}>
          <Form.Item noStyle>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Row>
      )}
    </Form>
  );
};

export default VirtualMappingForm;
